<template>
    <div class="off-account-page" v-if="isShow">
        <div class="dialog-mask"></div>
        <div v-if="stepNum == 0" class="common_fixed step_1">
            <span class="close-icon" @click="close"></span>
            <!-- <div class="mask-title">账号注销</div> -->
            <div class="mask-msg">
                注销前请认真阅读以下重要提醒。
            </div>
            <div class="mask-sub-msg">
                账号注销后，您将无法再使用该账号，包括但不限于:
            </div>
            <div class="content">
                1、无法登录、使用乐速游戏账号，并移除该账号下所有登录方式<br />
                2、移除该账号下的实名认证信息<br />
                3、该账号下的个人资料和历史信息都将无法找回<br />
                4、取消乐速游戏会员身份且无法恢复<br />
                5、无法继续的交易、售后流程等内容<br />
                <!-- <span> -->
                6、当前账号仍有余额或会员权益，注销成功后，账号余额将清零{{ vipTime }}<br />

                <!-- </span> -->
            </div>
            <div class="ensure-tip">
                <div :class="{ 'confirm-op': true, 'confirm-op-ok': goOnState }" @click="continueBtClick">
                    我已阅读并知晓了
                    <i v-if="goOnState"></i>
                </div>
                <div class="protocol" @click="protocolClick">《账号注销协议》</div>
            </div>

            <div class="operate-btn-wrap" @click="stepSecondClick">
                <span>继续注销</span>
            </div>
        </div>
        <div v-else-if="stepNum == 1" class="common_fixed step_2">
            <span class="close-icon" @click="close"></span>
            <div class="mask-title">请先验证身份</div>
            <div class="auth-tip">输入手机号进行绑定并注销验证</div>
            <div class="form-wrap">
                <div class="input">
                    <input ref="phoneInput" type="text" v-model="mobile" :disabled="mobileEdit" placeholder="请输入手机号" maxlength="11" oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')" />
                    <i class="error-tip" v-show="!isPhone">请输入11位手机号码</i>
                </div>
                <div class="input">
                    <input ref="codeInput" type="text" v-model="code" placeholder="请输入验证码" class="input-code" maxlength="6" @input="checkInputCode" @keyup="checkInputCode" @afterpaste="checkInputCode" />

                    <span :class="['get-code', isCountDown ? 'not-click' : '']" v-throttle="[getCode, 'click', 240]">
                        {{ isCountDown ? '倒计时' + formatTime(time) + 's' : '获取验证码' }}
                    </span>
                    <i class="error-tip" v-show="!isCode">请输入6位数字验证码</i>
                </div>
            </div>
            <div class="operate-btn-wrap">
                <template>
                    <span class="sp2-ok" @click="submitClick">
                        <i>确认注销</i>
                    </span>
                </template>
            </div>
        </div>
        <div v-else-if="stepNum == 2" class="common_fixed step_3">
            <span class="close-icon" @click="close"></span>
            <div class="mask-title">账号注销</div>
            <div class="content">
                <span>注销帐号申请已提交审核<br /></span>
                注销帐号申请将在7个工作日内完成审核，<br />
                正式注销前可通过帐号登录终止注销流程
            </div>
            <div class="operate-btn-wrap">
                <template>
                    <span class="sp2-ok" @click="close">
                        <i>确认</i>
                    </span>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import store from '@/store/store.js'
import { offAccountSendCode, offAccount } from '@/http/api/user'
import { serverTime } from '@/http/api/common'
import { datetime1 } from '@/utils/date.js'

export default {
    name: 'OffAccountDialog',
    data() {
        return {
            textAlign: 'center',
            isShow: false,

            vipTime: '',

            mobile: '',
            mobileEdit: false,
            code: '',
            isCountDown: false, // 是否在倒计时中
            time: 60, // 倒计时时间

            goOnState: false, // 是否继续
            stepNum: 0 // 步骤
        }
    },
    computed: {
        isPhone: function() {
            if (this.mobile) {
                return this.mobile.length < 11 ? false : true
            } else {
                return true
            }
        },
        isCode: function() {
            if (this.code) {
                return this.code.length < 6 ? false : true
            } else {
                return true
            }
        },

        vipExpireTime: function() {
            return datetime1(+new Date(store.state.vipInfo.expire_time))
        },
        is_vip: function() {
            return store.state.vipInfo.is_vip
        }
    },
    watch: {
        isShow: function(value) {
            if (value) {
                this.requestVIPState()
                this.$nextTick(() => {
                    this.$Utils.setDialogZindex('off-account-page')
                })
            } else {
                this.data = ''
            }
        }
    },
    methods: {
        show(callback) {
            if (store.state.userInfo.mobile.length > 10) {
                this.mobile = store.state.userInfo.mobile
                this.mobileEdit = true
            } else {
                this.mobileEdit = false
            }
            console.log(this.mobileEdit)

            if (callback) {
                this.callback = callback
            }

            this.isShow = true
        },

        requestVIPState() {
            var that = this
            serverTime().then(res => {
                if ((res.code = 200 && that.$Utils.isObject(res.data))) {
                    const leftTime = +new Date(that.vipExpireTime) - res.data.time * 1000
                    if (!store.state.vipInfo.expire_time && !that.is_vip) {
                        that.vipTime = '（您还没有开通会员）'
                    } else if (leftTime <= 0) {
                        that.vipTime = '（会员已过期）'
                    } else {
                        that.vipTime = `（您的会员到期时间为：${that.vipExpireTime}）`
                    }
                }
            })
        },

        close() {
            if (this.stepNum == 2) {
                // 已经注销成功了,
                this.callback()
            }
            this.isShow = false
            this.mobile = ''
            this.code = ''
            this.isCountDown = false // 是否在倒计时中
            this.time = 60 // 倒计时时间

            this.goOnState = false // 是否继续
            this.stepNum = 0 // 步骤
        },

        // 是否继续
        continueBtClick() {
            this.goOnState = !this.goOnState
            if (this.goOnState) {
            }
        },
        // 下一步
        stepSecondClick() {
            if (!this.goOnState) {
                return this.$Toast.show('请阅读并同意账号注销协议')
            }
            // 继续注销
            this.stepNum = 1
        },
        // 提交
        submitClick() {
            this.offAccountRequest()
        },

        protocolClick() {
            window.open(store.state.offAccountLink, '_blank')
        },

        checkInputCode(event) {
            let inputValue = this.code
            inputValue = inputValue.replace(/[^0-9]/g, '')
            if (inputValue.length > 6) {
                inputValue = inputValue.slice(0, 6)
            }
            this.code = inputValue

            if (event.key == 'Enter' || event.keyCode == 13 || event.code == 'Enter') {
                this.offAccountRequest()
            }
        },
        // 请求
        offAccountRequest() {
            if (!this.checkCodeSessionKey) {
                return this.$Toast.show('请先获取验证码')
            } else if (!this.mobile) {
                return this.$Toast.show('手机号码不能为空')
            } else if (!/^1[3-9]\d{9}$/.test(this.mobile)) {
                return this.$Toast.show('手机号码格式输入错误，请检查后重新输入')
            } else if (!/^\d{6}$/.test(this.code)) {
                return this.$Toast.show('请输入六位数字验证码')
            }

            var that = this
            offAccount({
                userName: this.mobile,
                code: this.code,
                checkCodeSessionKey: this.checkCodeSessionKey,
                form: 'box'
            }).then(function(res) {
                if (res.code == 200) {
                    that.stepNum = 2
                } else {
                    that.$Toast.show(res.msg)
                }
            })
        },

        getCode() {
            if (this.isCountDown) {
                return false
            } else if (!this.mobile) {
                return this.$Toast.show('手机号码不能为空')
            } else if (!/^1[3-9]\d{9}$/.test(this.mobile)) {
                return this.$Toast.show('手机号码格式输入错误，请检查后重新输入')
            } else {
                // 等滑块验证码背景图片完全加载出来才显示
                this.graphTimeid = setInterval(() => {
                    let img = $('.verify-img-panel img')
                    if (img) {
                        clearInterval(this.graphTimeid)
                        $('.verify-img-panel img').load(function() {
                            $(this).addClass('show')
                        })
                    }
                }, 100)

                sliderVerify(
                    'pop',
                    async res => {
                        if (res.token && res.captchaVerification) {
                            const data = {
                                userName: this.mobile,
                                token: res.token,
                                captchaVerification: res.captchaVerification
                            }

                            offAccountSendCode(data).then(res => {
                                if (res.code == 200 && this.$Utils.isObject(res.data)) {
                                    this.$refs.codeInput.focus()
                                    this.checkCodeSessionKey = res.data.checkCodeSessionKey
                                    this.isCountDown = true
                                    this.countDown()
                                } else {
                                    setTimeout(() => {
                                        this.$UpperTip.show(res.msg, '', '提示')
                                    }, 1200)
                                }
                            })
                        }
                    },
                    {
                        appKey: '42645'
                    }
                )
            }
        },

        // 倒计时
        countDown() {
            clearTimeout(this.timeId)
            if (this.time > 0) {
                this.timeId = setTimeout(() => {
                    this.time--
                    this.countDown()
                }, 1000)
            } else {
                this.time = 60
                this.isCountDown = false
            }
        },
        // 倒计时补0
        formatTime(time) {
            if (time < 10) {
                return '0' + time
            } else {
                return time
            }
        }
    }
}
</script>

<style lang="less" scoped>
.off-account-page {
    .common_fixed {
        position: fixed;
        z-index: 201;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background-color: @bg-color-dialog;
        border-radius: 10px;
        font-size: @font-size-normal;
        color: @color-txt-normal;

        .mask-title {
            margin-top: 50px;
            text-align: center;
            color: rgba(255, 255, 255, 0.9);
            font-size: @font-size-medium;
            line-height: 24px;
        }

        .operate-btn-wrap {
            user-select: none;
            position: absolute;
            bottom: 34px;
            left: 50%;
            transform: translateX(-50%);
            .flex-center();

            span {
                .button-linear();
                width: 240px;
            }
        }
    }

    .step_1 {
        width: 600px;
        height: 400px;

        .mask-msg {
            margin-top: 30px;
            font-size: @font-size-medium;
            padding-left: 50px;
            padding-right: 76px;
            line-height: 28px;
            color: #ffffff;
        }

        .mask-sub-msg {
            font-size: @font-size-normal;
            color: @color-txt-normal;
            padding-left: 50px;
            line-height: 28px;
        }

        .content {
            margin-top: 10px;
            padding: 0 50px;
            font-size: @font-size-normal;
            line-height: 26px;

            span {
                color: #fff;
                font-weight: 600;
            }
        }

        .ensure-tip {
            display: flex;
            align-items: center;
            height: 26px;
            line-height: 26px;
            margin-top: 10px;
            padding: 0 50px;

            .confirm-op {
                cursor: pointer;

                background-image: url(../../../assets/login/ic_radio.png);
                background-size: 13px;
                background-repeat: no-repeat;
                background-position-y: 6px;
                padding-left: 22px;
                // padding-right: 12px;
                position: relative;

                &:hover {
                    background-image: url(../../../assets/login/ic_radio_1.png);
                }

                i {
                    position: absolute;
                    left: 0;
                    top: 4px;
                    width: 15px;
                    height: 14px;
                    background: url(../../../assets/login/ic_checked.png) center no-repeat;
                }
            }
            .confirm-op-ok {
                background-image: url(../../../assets/login/ic_radio_1.png);
            }
            .protocol {
                color: #fff;
                cursor: pointer;
                &:hover {
                    color: @main-green-color;
                }
            }
        }
    }

    .step_2 {
        width: 540px;
        height: 380px;

        .auth-tip {
            margin-top: 35px;
            font-size: 14px;
            text-align: center;
            color: #fff;
        }

        .form-wrap {
            margin-top: 12px;
            margin-bottom: 16px;

            .input {
                position: relative;
                margin: 0 auto 24px;
                width: 360px;
                height: 40px;

                input {
                    width: 100%;
                    height: 100%;
                    line-height: 40px;
                    outline: none;
                    padding: 0 20px;
                    color: @color-txt-high;
                    border-radius: 20px;
                    border: none;
                    background: #090e0f;
                    font-size: @font-size-normal;

                    &::placeholder {
                        color: @color-txt-66;
                    }

                    &:focus {
                        background: url(../../../assets/input-bg.png) center/100% no-repeat;
                    }

                    &.input-code {
                        padding: 0 118px 0 24px;
                    }
                }

                .get-code {
                    position: absolute;
                    width: 118px;
                    height: 100%;
                    top: 0;
                    right: 0;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: @color-txt-normal;
                    font-size: @font-size-normal;
                    line-height: 22px;
                    cursor: pointer;
                    user-select: none;

                    &:hover {
                        color: @color-txt-high;
                    }

                    &.not-click {
                        cursor: not-allowed;
                    }
                }

                .error-tip {
                    position: absolute;
                    top: 41px;
                    left: 24px;
                    font-size: @font-size-small;
                    color: @color-number-yellow2;
                }
            }
        }
    }

    .step_3 {
        width: 540px;
        height: 340px;
        // background: url(../../assets/1.0.6/alert_bg_386_204.png) center/100% no-repeat;

        .content {
            margin-top: 40px;
            font-size: 14px;
            padding-left: 150px;
            line-height: 30px;
            // color: #AFD7DF;
            span {
                font-weight: 600;
                color: #ffffff;
            }
        }

        .hint_ic {
            position: absolute;
            top: 70px;
            left: 32px;
            width: 34px;
            height: 34px;
            // background: url(../../assets/steam_data/alert_tip_ic.png) center/100% no-repeat;
        }
    }
}
</style>
